import { faBookmark, faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { Helmet } from 'react-helmet-async';

const CorporateTransport = () => {
  return (
    <>
      <Helmet>
        <title>Corporate Van Rentals: Cost-Effective Employee Transport</title>
        <meta
          name="description"
          content="Learn how corporate van rentals offer a cost-effective, reliable solution for employee transport, office commutes, and business travel."
        />
      </Helmet>
      <div className="bg-[#fff] w-full flex flex-col">
        <section
          className="hero--container relative flex flex-col justify-center w-full bg-no-repeat bg-cover bg-center pt-[65px] mt-[140px] md:h-[60vh]"
          style={{ backgroundImage: `url('../images/corporate-transport.jpg')` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
          <div className="relative z-10">
            <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase leading-9">
              Corporate Van Rentals: A Cost-Effective Solution for Employee Transport
            </h1>

            <div className="flex justify-center items-center gap-4 mt-10 md:text-sm text-xs mb-2">
              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faClock} className="w-4" />
                <p className="blog-publish-date">11/05/2025</p>
              </div>

              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faComment} className="w-4" />
                <p className="blog-publish-date">12 Comments</p>
              </div>

              <div className="flex items-center gap-2 text-white">
                <FontAwesomeIcon icon={faBookmark} />
                <p className="blog-publish-date">1840 Views</p>
              </div>
            </div>
          </div>
        </section>

        <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24">
          <div className="mx-auto max-w-screen-md">
            <p className="pb-4 text-justify leading-7">
              In today's fast-paced business environment, ensuring reliable and efficient employee transportation is not just a matter of convenience — it’s a strategic decision. More companies are turning to corporate van rentals as a flexible and cost-effective alternative to managing their own fleet or reimbursing employee travel.
            </p>

            <p className="pb-4 text-justify leading-7">
              Whether you're shuttling teams between office locations, transporting staff to offsite events, or coordinating travel during large conferences, renting a van simplifies logistics and cuts down on the expenses associated with individual transportation methods like ride-shares or taxis. It’s particularly beneficial for companies needing short-term or long-term transportation without the burden of vehicle maintenance and insurance.
            </p>

            <p className="pb-4 text-justify leading-7">
              At JJ Van Rental, we provide a wide range of passenger vans perfect for group travel. Our corporate clients often choose long-term rentals to cover daily office commutes or regular client site visits. This approach not only ensures punctuality and consistency but also improves team cohesion by allowing employees to travel together.
            </p>

            <p className="pb-4 text-justify leading-7">
              Our services are tailored for convenience — we offer van delivery directly to your office, employee homes, or even the airport for maximum flexibility. With professional service and dependable vehicles, your team can travel safely and in comfort.
            </p>

            <p className="pb-4 text-justify leading-7">
              In addition to reliability, corporate van rentals reduce your environmental footprint. Fewer vehicles on the road mean reduced emissions, and by consolidating staff travel into fewer vans, your company plays a small but important role in promoting sustainable business practices.
            </p>

            <p className="pb-4 text-justify leading-7">
              If your business is ready to improve efficiency and reduce costs while offering your team dependable transportation, consider van rentals as a smart move forward. JJ Van Rental is here to help you simplify corporate travel, one ride at a time.
            </p>
          </div>
        </section>

        <section className="mb-8">
          <div className="max-w-screen-md mx-auto px-4 py-3 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            {/* Tags Section */}
            <div className="flex flex-wrap gap-2">
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Corporate Travel</p>
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Van Rentals</p>
              <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Employee Transport</p>
            </div>

            {/* Social Buttons Section */}
            <div className="flex flex-wrap items-center gap-3">
              <div className="flex items-center bg-[#42599E] px-3 py-2 rounded-lg text-white text-sm">
                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                  <FontAwesomeIcon icon={faFacebook} /> Share
                </a>
              </div>
              <div className="flex items-center bg-[#55ACEE] px-3 py-2 rounded-lg text-white text-sm">
                <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                  <FontAwesomeIcon icon={faTwitter} /> Tweet
                </a>
              </div>
              <div className="flex items-center bg-[#34AF23] px-3 py-2 rounded-lg text-white text-sm">
                <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                  <FontAwesomeIcon icon={faWhatsapp} /> WhatsApp
                </a>
              </div>
              <div className="flex items-center bg-[#0798CF] px-3 py-2 rounded-lg text-white text-sm">
                <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1">
                  <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
                </a>
              </div>
            </div>
          </div>

        </section>
      </div>
    </>

  );
};

export default CorporateTransport;